// extracted by mini-css-extract-plugin
export default {"root":"ErrorBanner-root-f3f7","close":"ErrorBanner-close-b439","icon":"ErrorBanner-icon-ef79","title":"ErrorBanner-title-dada","subtitle":"ErrorBanner-subtitle-bda4"};